import { MY_ANALYSIS_NODE_ID } from './adhocFolderTree';

export const ADHOC_ALL_BOARDS_NAV_KEY = 'adhoc-analysis-all-boards';
export const ADHOC_MY_ANALYSIS_NAV_KEY = 'adhoc-analysis-my-analysis';

const ALL_BOARDS_PATH = '/app/adhoc-analysis/all-boards';
const MY_ANALYSIS_PATH = '/app/adhoc-analysis/my-analysis';

type SideNavItem = {
  to?: string;
  uniqueKey?: string;
};

const parseAsPath = (asPath = ''): { path: string; folder: string | null } => {
  const [rawPath = '', rawQuery = ''] = asPath.split('?');
  const path = rawPath.split('#')[0];
  const query = rawQuery.split('#')[0];
  return { path, folder: new URLSearchParams(query).get('folder') };
};

export const personalFolderIdsFromState = (
  personalFolders: Array<{ id?: string | number | null }> = [],
  personalFolderId?: string | number | null
): string[] => {
  const ids = new Set<string>();
  if (personalFolderId != null && personalFolderId !== '') {
    ids.add(String(personalFolderId));
  }
  personalFolders.forEach((folder) => {
    if (folder?.id != null && folder.id !== '') {
      ids.add(String(folder.id));
    }
  });
  return [...ids];
};

const isMyAnalysisLocation = (asPath: string, personalFolderIds: Iterable<string> = []): boolean => {
  const { path, folder } = parseAsPath(asPath);
  if (path.includes(MY_ANALYSIS_PATH)) {
    return true;
  }
  if (folder === MY_ANALYSIS_NODE_ID) {
    return true;
  }
  if (folder == null || folder === '') {
    return false;
  }
  return new Set(Array.from(personalFolderIds, String)).has(folder);
};

/** Sidebar `pathname` is Next `asPath` (path + query). All Boards and My Analysis share all-boards. */
export const isSideNavItemActive = (
  item: SideNavItem,
  asPath = '',
  personalFolderIds: Iterable<string> = []
): boolean => {
  if (item.uniqueKey === ADHOC_MY_ANALYSIS_NAV_KEY) {
    return isMyAnalysisLocation(asPath, personalFolderIds);
  }
  if (item.uniqueKey === ADHOC_ALL_BOARDS_NAV_KEY) {
    return parseAsPath(asPath).path.includes(ALL_BOARDS_PATH) && !isMyAnalysisLocation(asPath, personalFolderIds);
  }
  return Boolean(item.to && asPath.includes(item.to));
};
